import { Validator, AbstractControl, FormControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export class DateValidator implements Validator {

    validate(c: AbstractControl): ValidationErrors | null {
        return DateValidator.validate(c);
    }

    static validate(c: AbstractControl): ValidationErrors | null {
        if (c.value && !moment(c.value, 'DDMMYYYY').isValid()) {               
            return { datevalidator: {valid: false}}              
        }
        return null;   
    }
}

